import React from 'react';
import logo from '../assets/images/logo.webp';
import '../styles/header.css';
import { FaGlobe } from 'react-icons/fa';


const Header = ({ language, toggleLanguage }) => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm">
      <div className="container">
        <a className="navbar-brand d-flex align-items-center gap-2" href="/">
          <img src={logo} alt="Club Logo" height="50" className="rounded-circle" />
<span className="fw-bold text-uppercase">
  {language === 'en' ? 'Officers Club' : 'የኦፊሰሮች ክለብ'}
</span>        </a>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav gap-3">
           <li className="nav-item">
  <a className="nav-link custom-nav-link" href="/">
    {language === 'en' ? 'Home' : 'ቀዳሚ ገፅ'}
  </a>
</li>
<li className="nav-item">
  <a className="nav-link custom-nav-link" href="/about">
    {language === 'en' ? 'About' : 'ስለ ተቋሙ'}
  </a>
</li>
<li className="nav-item">
  <a className="nav-link custom-nav-link" href="/news-events">
    {language === 'en' ? 'Event and News' : 'መረጃ እና ዜና'}
  </a>
</li>

{/* Services Dropdown */}
<li className="nav-item dropdown custom-dropdown">
  <a
    className="nav-link dropdown-toggle custom-nav-link"
    href="#services"
    id="servicesDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    {language === 'en' ? 'Services ▾' : 'አገልግሎቶች ▾'}
  </a>
  <ul className="dropdown-menu dropdown-menu-dark animate-slide-in" aria-labelledby="servicesDropdown">
    <li><a className="dropdown-item" href="/conference">{language === 'en' ? 'Conference Hall' : 'ኮንፈረንስ አዳራሽ'}</a></li>
    <li><a className="dropdown-item" href="/bar">{language === 'en' ? 'Restaurant & Kitchen' : 'ባር እና ሬስቶራንት'}</a></li>
    <li><a className="dropdown-item" href="/spa">{language === 'en' ? 'Spa & Steam Center' : 'ስፓ እና እንፋሎት ማዕከል'}</a></li>
    <li><a className="dropdown-item" href="/gym">{language === 'en' ? 'Fitness & Gym' : 'ፊትነስ እና ጂም'}</a></li>
    <li><a className="dropdown-item" href="/tennis">{language === 'en' ? 'Tennis Court' : 'ማዳ ቴኒስ መገለጫ'}</a></li>
    <li><a className="dropdown-item" href="/garden">{language === 'en' ? 'Garden & Grounds' : 'አረንጓዴ አካባቢ'}</a></li>
    <li><a className="dropdown-item" href="/other-services">{language === 'en' ? 'Others' : 'ሌሎች'}</a></li>
  </ul>
</li>
<li className="nav-item">
  <a className="nav-link custom-nav-link" href="/contact">
    {language === 'en' ? 'Contact Us' : 'አግኙን'}
  </a>
</li>
               <li className="nav-item">
              <button
                onClick={toggleLanguage}
                className="btn btn-outline-light d-flex align-items-center gap-2"
              >
                <FaGlobe /> {language === 'en' ? 'አማ' : 'EN'}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
